/* @flow strict */

import * as React from 'react';

import MetaContext, {
  type MetaContextType
} from './MetaContext';

const withMeta = <PropsType>(
  Component: React.AbstractComponent<{| ...PropsType, ...MetaContextType |}>
): React.AbstractComponent<PropsType> =>
  (props: PropsType): React.Element<typeof MetaContext.Consume> => (
    <MetaContext.Consumer>
      {(metaData: MetaContextType): React.Element<typeof Component> => <Component {...props} meta={metaData} />}
    </MetaContext.Consumer>
  );

export default withMeta;
